
export default function PanelSettings() {

  return (
    <div style={{padding:10}}>
    </div>
  );
}
